import React, {Fragment, useState, useEffect, useCallback, useRef} from 'react';
import {Flex, Video, Next, Link} from 'components';
import {config, cookies} from 'helpers';

export function Welcome() {
  useEffect(() => {
    cookies.set('welcomed', '1');
  }, []);

  return (
    <div className="text-center">
      <p>You have been successfully registered at <b className="nowrap">{ config.appName }!</b></p>
      { config.videos.welcome &&
        <div className="spacing">
          <Video.Video src={config.videos.welcome} />
        </div>
      }
      <p className="medium-spacing"><Next className="primary">Continue</Next></p>
      <p><Link className="link secondary" to="./quiz/intro/">Skip</Link></p>
    </div>
  );
}
